// extracted by mini-css-extract-plugin
export default {"root":"AdminStoriesList_root__tZ4VY","root_list":"AdminStoriesList_root_list__BUvpK","root_list_loading":"AdminStoriesList_root_list_loading__HiEP4"};